export default "__VITE_ASSET__Ciac4Kyy__"